import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import MainContainer from "../../layout/MainContainer";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  usePostAddNotificatiosnMutation,
  useLazyGetAllUserListNotificationQuery,
  useLazyGetAllCompanyQuery,
  useLazyGetAllAgentsQuery,
} from "../../services/notifications";
import { errorToast, successToast, warnToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { NOTIFICATION_TYPE, ROLE } from "../../constants/enums";
import EditText from "../../components/EditText";

const AddNotification = () => {
  const navigate = useNavigate();
  const [addNotification, { isLoading }] = usePostAddNotificatiosnMutation();
  const [receiver, setReceiver] = useState<any[]>([]);
  const [fetchAgents] = useLazyGetAllAgentsQuery();
  const [fetchUsers] = useLazyGetAllUserListNotificationQuery();
  const [fetchCompanies] = useLazyGetAllCompanyQuery();
  const [agentList, setAgentList] = useState<any[]>([]);
  const [userList, setUserList] = useState<any[]>([]);
  const [companyList, setCompanyList] = useState<any[]>([]);
  const [dropdownType, setDropdownType] = useState("");
  const [role, setRole] = useState<any>([]);
  const [selectAllFromFirstDropdown, setSelectAllFromFirstDropdown] =
    useState(false);
  const [message, setMessage] = useState<string>("");


  const handleDropdownTypeChange = async (event: any) => {
    const selectedType = event.target.value;
    setDropdownType(selectedType);
    setReceiver([]);
    setSelectAllFromFirstDropdown(selectedType === "Select All");

    if (selectedType !== "Select All") {
      switch (selectedType) {
        case "User":
          setRole(ROLE.INDIVIDUAL_USER);
          await fetchAllUsers();
          break;
        case "Agent":
          setRole(ROLE.AGENT);
          await fetchAllAgents(2);
          break;
        case "pendingAgent":
          setRole(ROLE.AGENT);
          await fetchAllAgents(1);
          break;
        case "Company":
          setRole(ROLE.AGENCY);
          await fetchAllCompanies(2);
          break;
        case "pendingCompany":
          setRole(ROLE.AGENCY);
          await fetchAllCompanies(1);
          break;
        default:
          setAgentList([]);
          setUserList([]);
          setCompanyList([]);
          setRole(null);
      }
    } else {
      setRole([]);
      setAgentList([]);
      setUserList([]);
      setCompanyList([]);
    }
  };

  const fetchAllAgents = async (status: number) => {
    try {
      const response = await fetchAgents({ isSendNotification: true }).unwrap();
      if (response?.statusCode === 200) {
        setAgentList(response?.data);
      }
    } catch (error: any) {
      errorToast(error.message);
    }
  };

  const fetchAllUsers = async () => {
    try {
      const response = await fetchUsers({}).unwrap();
      if (response?.statusCode === 200) {
        setUserList(response?.data);
      }
    } catch (error: any) {
      errorToast(error.message);
    }
  };

  const fetchAllCompanies = async (status: number) => {
    try {
      const response = await fetchCompanies({ isSendNotification: true, status: status }).unwrap();
      if (response?.statusCode === 200) {
        setCompanyList(response?.data);
      }
    } catch (error: any) {
      errorToast(error.message);
    }
  };

  const handleReceiverChange = (event: any, value: any) => {
    setReceiver(value);
    formik.setFieldValue("receiverId", value);
    formik.setFieldTouched("receiverId", true);
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      message: "",
      receiverId: receiver,
      notificationType: "",

    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Title is required")
        .min(2, "Minimum 2 characters are required"),
      notificationType: Yup.string()
        .required("Notification type is required"),
      // message: Yup.string().required("Message is required")

    }),
    onSubmit: async (values) => {
      if (dropdownType !== "Select All" && receiver.length === 0) {
        errorToast("Please select at least one receiver");
        return;
      }
      if (Number(formik.values.notificationType) === NOTIFICATION_TYPE.EMAIL && message?.length < 10) {
        warnToast("Please add a message");
        return;
      }

      let body: any = {
        title: formik.values.title,
        message: Number(formik.values.notificationType) === NOTIFICATION_TYPE.EMAIL ? message : values.message,
        notificationType: values.notificationType
      };


      if (
        selectAllFromFirstDropdown ||
        (receiver.length === 1 && receiver[0]._id === "Select All")
      ) {
        if (!selectAllFromFirstDropdown && dropdownType !== "pendingCompany" && dropdownType !== "pendingAgent") {
          body.role = role;
        } else if (!selectAllFromFirstDropdown && dropdownType === "pendingCompany") {
          body.role = role;
          body.status = 1;
        } else if (!selectAllFromFirstDropdown && dropdownType === "pendingAgent") {
          body.role = role;
          body.status = 1;
        }
      } else {
        body.role = role;
        body.users = receiver.map((rec) => rec._id);
      }
      console.log(body, "body");

      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await addNotification(encryptedBody).unwrap();
        if (response.statusCode === 200) {
          successToast(response?.message || "Notification Sent Successfully");
          navigate("/manage-notifications");
        } else {
          errorToast(response.message);
        }
      } catch (e: any) {
        errorToast(e?.data?.message || e?.message);
      }
    },
  });

  const getOptions = () => {
    const baseOptions = [{ name: "Select All", _id: "Select All", referenceId: "Select All", companyName: "Select All" }];
    switch (dropdownType) {
      case "User":
        return baseOptions.concat(userList);
      case "Agent":
        return baseOptions.concat(agentList);
      case "pendingAgent":
        return baseOptions.concat(agentList);
      case "Company":
        return baseOptions.concat(companyList);
      case "pendingCompany":
        return baseOptions.concat(companyList);
      default:
        return baseOptions;
    }
  };

  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1 className="mn_hdng">Add Notification</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-notifications");
              }}
            >
              Back
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Notification Title
                    </Typography>
                    <TextField
                      hiddenLabel
                      type="text"
                      name="title"
                      variant="outlined"
                      fullWidth
                      placeholder="Title"
                      value={formik.values.title}
                      onChange={(e) => { if (e.target.value !== " ") formik.handleChange(e) }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.title && Boolean(formik.errors.title)
                      }
                      helperText={
                        formik.touched.title && formik.errors.title
                          ? formik.errors.title.toString()
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Select Notification Type
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        value={formik.values.notificationType}
                        onChange={formik.handleChange}
                        displayEmpty
                        name="notificationType"
                        minRows={3}
                      >
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        <MenuItem value={NOTIFICATION_TYPE.EMAIL}>Email</MenuItem>
                        <MenuItem value={NOTIFICATION_TYPE.PUSH}>Simple Text Message</MenuItem>

                      </Select>
                    </FormControl>
                    {formik.touched.notificationType &&
                      formik.errors.notificationType && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.notificationType)}
                        </FormHelperText>
                      )}
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Select Receiver Type
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        value={dropdownType}
                        onChange={handleDropdownTypeChange}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select Receiver Type
                        </MenuItem>
                        <MenuItem value="User">User</MenuItem>
                        <MenuItem value="pendingAgent">Pending Agent</MenuItem>
                        <MenuItem value="Agent">Approved Agent</MenuItem>
                        <MenuItem value="pendingCompany"> Pending Company</MenuItem>
                        <MenuItem value="Company">Approved Company</MenuItem>
                        <MenuItem value="Select All">Select All</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>


                  {dropdownType !== "Select All" && (
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Select Receivers
                      </Typography>
                      <FormControl sx={{ width: "100%" }}>
                        <Autocomplete
                          multiple
                          options={getOptions()}
                          getOptionLabel={(option) => dropdownType === "Company" || dropdownType === "pendingCompany" ? option.companyName + "(" + option.referenceId + ")" : option.name + "(" + option.referenceId + ")"}
                          value={receiver}
                          onChange={handleReceiverChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Search and select receivers"
                              error={
                                formik.touched.receiverId &&
                                Boolean(formik.errors.receiverId)
                              }
                              helperText={
                                formik.touched.receiverId &&
                                  formik.errors.receiverId
                                  ? formik.errors.receiverId.toString()
                                  : ""
                              }
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  )}

                  {Number(formik.values.notificationType) === NOTIFICATION_TYPE.EMAIL ? (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className="custom_label">
                        Notification Message
                      </Typography>
                      <EditText
                        content={message}
                        setContent={setMessage}
                      />

                    </Grid>
                  ) : (
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Typography className="custom_label">
                        Notification Message
                      </Typography>
                      <TextField
                        hiddenLabel
                        type="text"
                        name="message"
                        variant="outlined"
                        fullWidth
                        placeholder="Message"
                        value={formik.values.message}
                        onChange={(e) => { if (e.target.value !== " ") formik.handleChange(e) }}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.message && Boolean(formik.errors.message)
                        }
                        helperText={
                          formik.touched.message && formik.errors.message
                            ? formik.errors.message.toString()
                            : ""
                        }
                      />
                    </Grid>
                  )}

                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div >
      </div >
    </>
  );
};

export default AddNotification;
